export const contentData = {
  spanish:{
    title:'Crear publicidad',
    nodata:'Sin Registro',
    error:'Sin registro',
    button:'Guardar',
    cancelButton:'Cancelar',
    image_button:'Cambiar',
    form:{
      name:{
        label:'Nombre',
        placeholder:'Nombre',
      }, 
      specs:{
        label:'Especificaciones',
        placeholder:'Especificaciones',
      },
      due_date:{
        label:'Fecha Requerida',
        placeholder:'Fecha Requerida',
      }, 
      periodicity_id:{
        label:'Periodicidad',
        placeholder:'Fecha de inicio',
      }, 
      responsible_id:{
        label:'Responsable',
        placeholder:'Responsable'
      },
      estimated_delivery_date:{
        label:'Fecha Estimada de Entrega',
        placeholder:'Fecha Estimada de Entrega'
      },
      project_costs:{
        label:'Costos del Proyecto',
        placeholder:'Costos del Proyecto',
      }, 
      cost:{
        label:'Costo',
        placeholder:'Costo'
      },
      sell_price:{
        label:'Precio de Venta',
        placeholder:'Precio de Venta'
      }
    },
  },
}